export default __webpack_public_path__ + "static/media/delievers22.dd7b0ac3.jpeg";